import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentUserId } from 'store/storeValtio';
import Spinner from '../spinner/Spinner';
import { lookupMed } from 'helpers/medicationHelpers';
import SupplementSearch from './SupplementSearch';
import SupIngredientList from './SupIngredientList';
import chevLeft from 'icons/chevron-left-24.png';

export default function SupAddIngredients(props) {
  const params = useParams();
  const medId = params.id;
  const currentUserId = getCurrentUserId();
  const navigate = useNavigate();

  console.log('SupAddIngredients', medId);

  const [mode, setMode] = useState(0);
  const [med, setMed] = useState(null);
  const [labelId, setLabelId] = useState(0);

  useEffect(() => {
    console.log('SupAddIngredients UE');
    const med = lookupMed(medId);
    setMed(med);
  },[]);

  if (!med) return (<Spinner/>);

  function updateLabelId(l) {
    console.log('updateLabelId',l);
    setLabelId(l);
    setMode(1);
  }

  function prev() {
    navigate(-1);
  }

  return (
    <div className='mcard'>
      <div className='mcard-header'>
          <div className='hover:cursor-pointer'>
            <div className='hover:cursor-pointer' onClick={()=>prev()}>
              <img src={chevLeft} alt='' />
            </div>
          </div>
          <div className='font-bold text-xl'>
            Ingredients for {med.name}
          </div>
          <div></div>
      </div>

        {mode === 0 && <SupplementSearch med={med} updateLabelId={updateLabelId} /> }
        {mode === 1 && <SupIngredientList med={med} labelId={labelId} /> }
    </div>
    )
}